import React from 'react';
import { Configure } from 'react-instantsearch-dom';

// Components
import EventListItemRedesign from '@molecules/EventListItemRedesign';
import LoadingArea from '@molecules/LoadingArea';
import SearchContainer from '@search/SearchContainer';
import SearchHits from '@search/SearchHits';

// Functionality
import useMyEventHistoryFilters from '../../../hooks/algoliaFilters/useMyEventHistoryFilters';
import { SAVED_EVENTS_QUERY } from '@general/graphql/event.graph';
import { mapSearchEventToProps } from '@general/transforms/event.transform';

const SearchEventsRecentlyAttended = () => {
    const { filters } = useMyEventHistoryFilters();

    if (filters.length === 0) {
        return <LoadingArea />;
    }

    return (
        <SearchContainer index="events_meeting_start_time_asc">
            <Configure clickAnalytics filters={filters} hitsPerPage={3} />
            <SearchHits
                HitComponent={EventListItemRedesign}
                favoritesProp="viewerEvents"
                favoritesQuery={SAVED_EVENTS_QUERY}
                index="events_meeting_start_time_asc"
                NoResultsText={() => <>Looks like you have no past events. Register for an upcoming event!</>}
                resultsPerRow={1}
                searchType="events"
                shouldLogConversions={false}
                transformFunc={mapSearchEventToProps}
            />
        </SearchContainer>
    );
};

export default SearchEventsRecentlyAttended;
